<template>
  <v-expansion-panels elevation="0" style="padding: 30px; border-radius: 20px">
    <v-expansion-panel>
      <v-expansion-panel-header style="padding: 35px;">
        <h3 style="color:#42352E;">Búsqueda detallada</h3>
      </v-expansion-panel-header>
      <v-expansion-panel-content>
        <v-form ref="form" v-model="isFormValid" lazy-validation>
          <v-row>
            <v-col cols="12" md="4">
              <v-autocomplete
                v-model="form.alianza_intermx_id"
                label="Alianza Intermx"
                :items="alianzas"
                item-text="nombre"
                item-value="id"
                outlined
                dense
                background-color="white"
                class="share-bar-clase"
                :rules="[(v) => !!v || 'El campo es requerido']"
              />
            </v-col>
            <v-col cols="12" md="4">
              <v-menu
                v-model="menuFecha"
                :close-on-content-click="false"
                max-width="290"
              >
                <template #activator="{ on, attrs }">
                  <v-text-field
                    :value="datesSelectedString"
                    label="Rango de creación"
                    outlined
                    dense
                    v-on="on"
                    v-bind="attrs"
                    readonly
                    prepend-inner-icon="mdi-calendar"
                    :light="true"
                    background-color="white"
                    class="share-bar-clase"
                    :rules="[validateRangoFecha()]"
                  ></v-text-field>
                </template>
                <v-card class="pa-0">
                  <v-date-picker
                    v-model="form.fecha_emision"
                    range
                    locale="es"
                    selected-items-text="2 seleccionadas"
                  ></v-date-picker>
                  <v-card-actions>
                    <v-btn small text @click="form.fecha_emision = []"
                      >Limpiar</v-btn
                    >
                    <v-spacer></v-spacer>
                    <v-btn small text color="primary" @click="menuFecha = false"
                      >Listo</v-btn
                    >
                  </v-card-actions>
                </v-card>
              </v-menu>
            </v-col>
            <v-col cols="12" style="text-align: end;">
              <v-btn
                dark
                outlined
                color="#00a7e4"
                rounded
                class="mr-2"
                @click="clearForm()"
                min-width="120"
              >
                Limpiar
              </v-btn>
              <v-btn
                class="common-botton mr-2"
                min-width="120"
                rounded
                dark
                :loading="loading"
                @click="updateSearch"
              >
                <span>Filtrar</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script>
import { getAlianzas } from "@/services/alianzas/alianzas.service.js";
import moment from "moment";

export default {
  props: {
    currentFilters: {
      type: Object,
      default: () => {},
    },
    currentAlianza: {
        type: Object,
        default: () => { },
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      form: {
        fecha_emision: [],
        alianza_intermx_id: "",
      },
      menuFecha: false,
      alianzas: [],
      isFormValid: true,
    };
  },

  computed: {
    datesSelectedString() {
      if (this.form.fecha_emision.length > 1)
        return `${this.formatDate(
          this.form.fecha_emision[0]
        )} a ${this.formatDate(this.form.fecha_emision[1])}`;
      return "";
    },
  },
  watch: {
    currentFilters(v) {
      !!v && this.setCurrent();
    },
  },

  mounted() {
    this.setCurrent();
    this.getAlianzasList();
  },

  methods: {
    async getAlianzasList() {
      this.alianzas = await getAlianzas();
    },

    formatDate(date) {
      return moment(date).format("DD/MM/YYYY");
    },

    updateSearch() {
        const formValid = this.$refs.form.validate();
        if (!formValid) return;

        let payload = {};

        Object.keys(this.form).forEach((key) => {
            const value = this.form[key];
            if (value !== null && value !== undefined && (value || value === 0)) {
                payload[key] = typeof value === "string" ? value.trim() : value;
            }
        });

        const alianzaSeleccionada = this.alianzas?.find(item => item.id == payload.alianza_intermx_id);
        if (!alianzaSeleccionada) {
            console.warn("No se encontro la alianza")
            return;
        }
        this.$emit('alianzaUpdated', alianzaSeleccionada);
        this.$emit("searchUpdated", payload);
    },


    setCurrent() {
      this.clearForm();
      this.form = { ...this.form, ...this.currentFilters };
    },

    clearForm() {
      Object.keys(this.form).forEach((key) => {
        if (Array.isArray(this.form[key])) {
          this.form[key] = [];
        } else {
          this.form[key] = "";
        }
      });
    },

    validateRangoFecha() {
      const fechas = this.form.fecha_emision;
      return Array.isArray(fechas) &&
        fechas.length === 2 &&
        fechas[0] &&
        fechas[1]
        ? true
        : "El campo requiere un rango válido";
    },
  },
};
</script>
<style scoped>
.v-expansion-panel {
  border-radius: 20px;
}

.v-expansion-panels {
  z-index: auto !important;
}

.v-expansion-panels:not(.v-expansion-panels--accordion):not(.v-expansion-panels--tile)
  > .v-expansion-panel--active {
  border-radius: 20px !important;
  background-color: #f7f8fa;
}

.v-expansion-panel-header {
  background-color: #f7f8fa;
  border-radius: 20px !important;
}

@media (max-width: 600px) {
  .button-container {
    margin-bottom: 15px;
    /* Ajusta el espacio */
  }
}
</style>
